import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'vfootball-favorites-v1';

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { teams: [], leagues: [] };
    return JSON.parse(raw);
  } catch {
    return { teams: [], leagues: [] };
  }
};

const save = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {}
};

export default function useFavorites() {
  const [favs, setFavs] = useState(load);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setFavs(load());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const toggleTeam = useCallback((teamId) => {
    setFavs(prev => {
      const teams = prev.teams.includes(teamId)
        ? prev.teams.filter(id => id !== teamId)
        : [...prev.teams, teamId];
      const next = { ...prev, teams };
      save(next);
      return next;
    });
  }, []);

  const toggleLeague = useCallback((leagueId) => {
    setFavs(prev => {
      const leagues = prev.leagues.includes(leagueId)
        ? prev.leagues.filter(id => id !== leagueId)
        : [...prev.leagues, leagueId];
      const next = { ...prev, leagues };
      save(next);
      return next;
    });
  }, []);

  const isTeamFav = useCallback((id) => favs.teams.includes(id), [favs.teams]);
  const isLeagueFav = useCallback((id) => favs.leagues.includes(id), [favs.leagues]);

  return { favs, toggleTeam, toggleLeague, isTeamFav, isLeagueFav };
}
